import React, {useState} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import ChildRow from "../components/FilterRow";

export default function FilterTypeRow({label, filters}){
	
	const [displayFilters, setDisplayFilters] = useState("none");
	const [icon, setIcon] = useState("angle-right");
	
	const thisContainer = {
		display:"flex",
		width:"100%",
		flexDirection:"column"
	};
	
	const titleRow = {
		display:"flex",
		height:"20px",
		width:'100%',
		alignItems:"center"
	}
	
	const checkStyle = {
		display:"flex",
		color:"#759EFF",
		width:"12px",
		height:"12px",
		margin:"10px",
		cursor:"pointer"
	};
	
	const labelStyle ={
		display:"flex",
		color:"black",
		fontSize:"14px"
	};
	
	
	const handleClick = () => {
		if(displayFilters === "none"){
			setDisplayFilters("flex");
			setIcon("angle-down");
		}
		else{
			setDisplayFilters("none");
			setIcon("angle-right");
		}
	};
	
	const filterContainer = {
		display:displayFilters,
		marginLeft:"10px",
		width:"calc(100% - 10px)",
		flexDirection:'column'
	};
	
	const filterDisplay = filters.map((item, index) => 
		<ChildRow
			label={item.label}
			filters={item.filters}
		/>
	);
	
	return (
		<div style={thisContainer}>
			<div style={titleRow}>
				<input type="checkbox" style={checkStyle} onClick={handleClick}/>
				<div style={labelStyle}>
					{label}
				</div>
			</div>
			<div style={filterContainer}>
				{filterDisplay}
			</div>
		</div>
	);
}